/**
 * Qué fechas puede elegir la impulsadora para su cierre de turno.
 *
 * Pedido del usuario del 25-oct: *«si le puedes filtrar y solo ponerle sábado y domingo en esa opción… para que no se
 * confundan y no pongan otras fechas»*. Ese domingo se anularon los cierres del sábado y cada impulsadora llenó dos.
 * Con el calendario libre podía poner cualquier día; ahora elige entre los días de SUS turnos aprobados de los últimos
 * `DIAS_PARA_CERRAR` días, hoy incluido, y nunca uno futuro. Vital trabaja sábado y domingo, así que el domingo ve
 * esas dos; fijas, de viernes a domingo. Un cierre más viejo lo completa la oficina desde la bandeja.
 */
export const DIAS_PARA_CERRAR = 3;

const DIAS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'setiembre', 'octubre',
  'noviembre', 'diciembre'];

/** `iso` (YYYY-MM-DD) menos `n` días. Se calcula a mediodía UTC para no depender de la zona del celular. */
export function restarDias(iso: string, n: number): string {
  const d = new Date(`${iso}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() - n);
  return d.toISOString().slice(0, 10);
}

/** Las fechas de sus turnos entre `hoy - (dias - 1)` y `hoy`, sin repetir y en orden. */
export function fechasParaElegir(
  turnos: readonly { position: { date: string } }[],
  hoy: string,
  dias = DIAS_PARA_CERRAR,
): string[] {
  const desde = restarDias(hoy, dias - 1);
  return [...new Set(turnos.map((t) => t.position.date))].filter((f) => f >= desde && f <= hoy).sort();
}

/** «Sábado 24 de octubre», y «(hoy)» al de hoy. */
export function nombreDeFecha(iso: string, hoy: string): string {
  const d = new Date(`${iso}T12:00:00Z`);
  const nombre = `${DIAS[d.getUTCDay()]} ${d.getUTCDate()} de ${MESES[d.getUTCMonth()]}`;
  return iso === hoy ? `${nombre} (hoy)` : nombre;
}
